// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"ImageCardModal_modalWrapper__2Kdau","modalCard":"ImageCardModal_modalCard__28Z2f","removeIcon":"ImageCardModal_removeIcon__JjMVP"};